export default {
  data() {
      return {
          freeShippingPlatformList: [
            'Web',
            'Phone',
            'Email',
            'Post',
          ]
      }
  }
}



